import * as v from 'valibot';

const DiscussionWithoutReplies = v.object({
  id: v.number(),
  body: v.string(),
  created: v.string(),
  author: v.object({
    id: v.number(),
    name: v.nullish(v.string()),
    thumbnail: v.nullish(v.string()),
  }),
  flags: v.object({
    delete: v.boolean(),
    owner: v.boolean(),
    read: v.boolean(),
    reply: v.boolean(),
  }),
  tag: v.nullish(v.string()),
  topicId: v.string(),
});

export const DiscussionSchema = v.merge([
  DiscussionWithoutReplies,
  v.object({
    replies: v.array(DiscussionWithoutReplies),
  }),
]);

export type TReply = v.Output<typeof DiscussionWithoutReplies>;
export type TDiscussion = v.Output<typeof DiscussionSchema>;
